import { useQuery } from '@tanstack/react-query'

import { api } from '@/shared/api/client'
import type { MetricsInsights, TeamMetrics } from '@/shared/api/contracts'
import { qk } from '@/shared/api/query-keys'

/**
 * `GET /projects/metrics` — los tres cortes en UN request.
 *
 * Total, por empresa y por persona viajan juntos a propósito: se miran juntos y
 * tienen que cuadrar. Pedirlos en tres requests permitiría que salieran de tres
 * estados distintos de la base, y un tablero cuyos números no suman entre sí no
 * se cuestiona —se abandona.
 *
 * No recibe filtros: esta pantalla contesta "cómo viene el equipo", y el
 * alcance (qué empresas entran) lo pone RLS.
 */
export function useTeamMetrics() {
  return useQuery({
    queryKey: qk.portfolio.metrics(),
    queryFn: () => api.get<TeamMetrics>('projects/metrics'),
  })
}

/**
 * `GET /projects/metrics/insights` — las tendencias.
 *
 * Aparte de `useTeamMetrics` y no dentro, por costo: el tablero de arriba son
 * los números de hoy y se pide en cada visita; esto barre doce semanas de
 * historia. Quien sólo mira la cabecera no paga el barrido, y la pantalla puede
 * dibujar la parte de arriba mientras la de abajo todavía viene en camino.
 */
export function useMetricsInsights() {
  return useQuery({
    queryKey: qk.portfolio.insights(),
    queryFn: () => api.get<MetricsInsights>('projects/metrics/insights'),
  })
}
